import { useConfigStore } from "@/stores/config";

export default function useFeaturesData() {
  const configStore = useConfigStore();

  function highwayCounty(detail) {
    const c = configStore.getCountyByCountyCode(detail.paCounty);
    return c ? `${c.countyCode} - ${c.countyName}` : detail.paCounty;
  }

  return {
    highwayCounty,
  };
};
